import { FC, FormEvent } from 'react';
import { formOptions } from '@tanstack/react-form';
import { useAppForm } from '@new/common/hooks/form';

const bioFormOpts = formOptions({
  defaultValues: {
    aboutUs: '',
  },
});

export const BioForm: FC = () => {
  const form = useAppForm({
    ...bioFormOpts,
    defaultValues: {
      aboutUs: '',
    },
    validators: {
      onSubmit: ({ value }) => {
        // TODO: submit bio update
        console.log('Submitting bio:', value);
        return undefined;
      },
    },
  });

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    form.handleSubmit();
  };

  return (
    <form onSubmit={onSubmit} className="flex flex-col gap-5">
      <form.AppField
        name="aboutUs"
        children={(field) => (
          <field.Textarea label="About Us" placeholder="Tell us about yourself..." disabled />
        )}
      />

      <form.AppForm>
        <form.SubmitButton label="Save changes" />
      </form.AppForm>
    </form>
  );
};
